(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/service-fraction/assets/utils/track-fractions.js') >= 0) return;  svs.modules.push('/components/payment/service-fraction/assets/utils/track-fractions.js');


'use strict';

const {
  analytics
} = svs.components;
const {
  getDisplayName
} = svs.components.lbUtils.sportProducts;
const {
  resolveITSProductId
} = svs.utils.products;
const {
  PRIVATE
} = svs.components.marketplaceData.constants.groupTypeNames;

const getUniqueOrderId = transactionId => {
  const orderId = transactionId || "order-".concat(Date.now(), "-").concat(Math.random().toString(36).slice(2, 7));
  return orderId;
};

const trackFractions = function (payableItemsData) {
  let userContext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    payable,
    dto
  } = (payableItemsData === null || payableItemsData === void 0 ? void 0 : payableItemsData[0]) || {};
  const {
    trackingData
  } = userContext;
  const {
    groupName,
    gameName,
    typeOfGroup
  } = trackingData;
  const items = [];
  const itsName = resolveITSProductId(payable.productId);
  const type = typeOfGroup === PRIVATE ? 'c2c' : 'r2c';
  const SKU = "".concat(itsName, " ").concat(type);
  const ticketsTotal = dto.purchasedShares;
  const totalAmount = dto.cost;
  const fractionPrice = payable.fractionPrice;
  const productName = getDisplayName(payable.productId);
  const details = {
    agentName: groupName,
    gameName,
    ticketsTotal
  };
  const trackingItem = new analytics.transactionItem(SKU,
  productName,
  fractionPrice,
  1,
  details 
  );
  items.push(trackingItem);
  const orderId = getUniqueOrderId(dto.transactionId);
  const transaction = new analytics.transaction(orderId, totalAmount, items, 0, 0);
  analytics.trackTransaction(transaction);
};
setGlobal('svs.components.payment.serviceFraction.utils.trackFractions', trackFractions);

 })(window);